/**
 * Ordem dos imóveis na tela (out/2026, pedido do Bruno): favoritos primeiro,
 * depois a ordem que o cliente escolheu arrastando (`displayOrder`), e por
 * último quem nunca foi reordenado, na ordem em que a API devolveu (cadastro).
 * Usada pelo Dashboard e pela lista de Imóveis — as duas telas mostram a mesma
 * ordem. Os favoritos ficam sempre no topo: arrastar reordena dentro do grupo.
 */
interface Orderable {
  id: string;
  isFavourite?: boolean;
  displayOrder?: number | null;
}

export const sortConsumerUnits = <T extends Orderable>(list: T[]): T[] =>
  list
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const favA = a.item.isFavourite ? 0 : 1;
      const favB = b.item.isFavourite ? 0 : 1;
      if (favA !== favB) return favA - favB;
      const ordA = a.item.displayOrder ?? Number.POSITIVE_INFINITY;
      const ordB = b.item.displayOrder ?? Number.POSITIVE_INFINITY;
      if (ordA !== ordB) return ordA - ordB;
      return a.index - b.index;
    })
    .map(({ item }) => item);

/** Ids com `movedId` colocado na posição de `targetId`. */
export const moveToPosition = (
  ids: string[],
  movedId: string,
  targetId: string
): string[] => {
  if (movedId === targetId) return ids;
  const without = ids.filter((id) => id !== movedId);
  const targetIndex = without.indexOf(targetId);
  if (targetIndex < 0 || !ids.includes(movedId)) return ids;
  const movingDown = ids.indexOf(movedId) < ids.indexOf(targetId);
  without.splice(movingDown ? targetIndex + 1 : targetIndex, 0, movedId);
  return without;
};

/** Ids com `movedId` uma posição antes (-1) ou depois (+1). */
export const moveByStep = (
  ids: string[],
  movedId: string,
  step: -1 | 1
): string[] => {
  const index = ids.indexOf(movedId);
  const target = index + step;
  if (index < 0 || target < 0 || target >= ids.length) return ids;
  const next = [...ids];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
};
